import React from 'react';
import {
    IGameContextViewModel
} from "../../../../../../../services/game-runner/interfaces/game-context/game-context-view-model.interface";
import {observer} from "mobx-react";
import {OrbitComponent} from "../../../../../../base-components/orbit-component/orbit-component";
import {GamePlayMobileHeaderBarComponent} from "../../game-play-mobile-header-bar.component";
import {BottomSectionBox} from "./boxes/bottom-section.box";
import {TopSectionBox} from "./boxes/top-section.box";
import {GamePlayMobileHeaderBarClockComponent} from "../../parts/clock/game-play-mobile-header-bar-clock.component";
import {NetPositionComponent} from "../../../../../common/parts/net-position/net-position.component";
import {GameDurationComponent} from "../../../../../common/parts/game-duration/game-duration.component";
import {BottomLeftSectionBox} from "./boxes/bottom-left-section.box";
import {BottomRightSectionBox} from "./boxes/bottom-right-section.box";
import {TopRightSectionBox} from "./boxes/top-right-section.box";
import {TopLeftSectionBox} from "./boxes/top-left-section.box";
import {
    OntarioResponsibleGamingButtonsComponent
} from "../../../../../../responsible-gambling/responsible-gaming-buttons/regulations/ontario/ontario.responsible-gaming-buttons.component";

interface OntarioGamePlayMobileHeaderBarComponentProps {
    gameContext: IGameContextViewModel;
    shouldShowNetPosition: boolean;
}

export const OntarioGamePlayMobileHeaderBarComponent = observer(
    class OntarioGamePlayMobileHeaderBarComponent extends OrbitComponent<OntarioGamePlayMobileHeaderBarComponentProps> {

        private _renderTopSection = () => {
            if(this.props.shouldShowNetPosition) {
                return (<TopSectionBox>
                    <TopRightSectionBox>
                        <OntarioResponsibleGamingButtonsComponent/>
                    </TopRightSectionBox>
                </TopSectionBox>);
            }

            return(
            <TopSectionBox>
                <TopLeftSectionBox>
                    <GamePlayMobileHeaderBarClockComponent/>
                </TopLeftSectionBox>
                <TopRightSectionBox>
                    <OntarioResponsibleGamingButtonsComponent/>
                </TopRightSectionBox>
            </TopSectionBox>);
        }

        private _renderBottomSection = () => {

            if(!this.props.shouldShowNetPosition) {
                return null;
            }

            return (<BottomSectionBox>
                <BottomLeftSectionBox>
                    <NetPositionComponent gameContext={this.props.gameContext}/>
                </BottomLeftSectionBox>

                <GamePlayMobileHeaderBarClockComponent/>

                <BottomRightSectionBox>
                    <GameDurationComponent gameContext={this.props.gameContext}/>
                </BottomRightSectionBox>

            </BottomSectionBox>);
        }

        render() {
            return (
                <GamePlayMobileHeaderBarComponent gameContext={this.props.gameContext}
                                                  renderTopLeftSection={this._renderTopSection}
                                                  renderBottomSection={this._renderBottomSection}/>

            )
        }
    }
);